// extracted by mini-css-extract-plugin
module.exports = {"header":"BRkW5","shake":"eI5TV"};